// extracted by mini-css-extract-plugin
export default {"logo":"login_logo__qD+bE","log":"login_log__S8x3t","logItem":"login_logItem__2MwMP","logButton":"login_logButton__rgGEP","info":"login_info__Ta3Zb"};